import { DesktopTimePicker, TabContext, TabList, TimePicker } from "@mui/lab";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Tooltip,
  TooltipProps,
  Typography,
  styled,
  tooltipClasses,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { ChangeEvent } from "react";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import CancelIcon from "@mui/icons-material/Cancel";
import galleryIcon from "./../../../../assets/icons/upload.png";
import loading from "./../../../../assets/images/LoadingSpin.gif";
import plusIcon from "./../../../../assets/icons/plus.png";
import Cancel from "./../../../../assets/icons/close.png";
import AddEmpDialog from "./../../../restaurantsetup/components/AddEmployeeDialog/AddEmployeeDialog.tsx";
import Schedulepreviwdialog from "./../../../product/components/SchedulerView/ScheduleItemDialog/SchedularPreviewDialog/SchedularPreviewDialog.tsx";
import "./AddRestaurantDialog.css";
import TimingComponenet from "../../../components/TimingComponenet/TimingComponenet.tsx";
import SchedulerComponent from "../../../product/components/SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx";
import axios from "axios";
import jwt_decode from "jwt-decode";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoadingView from "./../../../components/LoadingView/LoadingView.js";
import RestaurantTable from "../../../components/SpecificationTable/RestaurantTable.tsx";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import Chip from "@mui/material/Chip";
import AddFoodCategoryDialog from "../FoodCategory/AddfoodCategory.tsx";

import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import img1 from "../../../../assets/icons/user (1).png";
import AddressAddModal from "../AddressModal/AdressAddModal.jsx";
import {
  Autocomplete as GooglePlacesAutocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";
// Type definitions
interface ImageUploadState {
  selectedImages: string[];
}

function AddRestaurantDialog(props) {
  const [value, setValue] = React.useState("1");
  const [switchCheck, setswitchCheck] = useState(false);
  const [isChain, setisChain] = useState(true);
  const [defaultvalue, setDefaultvalue] = useState({});
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [lastOrder, setlastorder] = useState([]);

  const [lastOrderTime, setLastOrderTime] = React.useState([]);
  const [lastOrderTimeConfirmed, setLastOrderTimeConfirmed] = useState(false); // Track if last order time is confirmed
  const getLastOrderTime = (props) => {
    console.log(props);
    setLastOrderTime(props);
    setLastOrderTimeConfirmed(false); // Reset confirmation when time is changed
  };

  const [confirmedLastOrderTimes, setConfirmedLastOrderTimes] = useState([]);
  const [selectedSchedularObj, setselectedSchedularObj] = React.useState([]);

  const [openAddSection, setOpenAddSection] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [addressCoordinates, setAddressCoordinates] = useState({
    latitude: null,
    longitude: null,
  });

  const [restaurantModalOpen, setRestaurantModalOpen] = useState(props.open);

  useEffect(() => {
    setRestaurantModalOpen(props.open);
  }, [props.open]);

  // To open address modal: close restaurant first
  const handleOpenAddressModal = () => {
    setRestaurantModalOpen(false); // Hide restaurant modal
    setShowAddressModal(true); // Show address modal
  };

  // To close address modal: restore restaurant modal
  const handleCloseAddressModal = () => {
    setShowAddressModal(false);
    setRestaurantModalOpen(true); // Reopen restaurant modal
  };

  // Add this handler function
  const handleAddressSelect = (addressData) => {
    console.log("Selected address:", addressData);

    // Update the address field
    setSelectedAddress(addressData.address);
    // newRestaurant.AddressLine1 = addressData.address;

    setNewRestaurant((prev) => ({
      ...prev,
      AddressLine1: addressData.address,
      Latitude: addressData.latitude,
      Longitude: addressData.longitude,
    }));

    // Store coordinates for future use
    setAddressCoordinates({
      latitude: addressData.latitude,
      longitude: addressData.longitude,
    });

    // Optionally, you can also auto-fill PostCode if available
    // Parse postcode from address if needed
    const postcodeMatch = addressData.address.match(
      /[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}/i,
    );
    if (postcodeMatch) {
      newRestaurant.PostCode = postcodeMatch[0];
    }
  };

  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  const handleOpenFoodCategory = (AddSectionData) => {
    setOpenAddSection(AddSectionData);
    // loadData();
  };
  // const handleConfirmLastOrderTimes = (lastOrderTimes) => {
  //   setConfirmedLastOrderTimes(lastOrderTimes);
  // };

  const handleConfirmLastOrderTimes = (lastOrderTimes) => {
    setConfirmedLastOrderTimes(lastOrderTimes);
    setLastOrderTimeConfirmed(true); // Set confirmation to true
    // if (lastOrderTimes.length > 0) {
    //   setConfirmedLastOrderTimes(lastOrderTimes);
    //   setLastOrderTimeConfirmed(true); // Set confirmation to true
    // } else {
    //   toast.error("Please select a last order time before confirming.", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    // }
  };

  const [openConfirmaitonModalManager, setopenConfirmaitonModalManager] =
    useState(false);

  const handleAddItem = (AddSectionData) => {
    // setOpenAddSection(AddSectionData)
    console.log("object");
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  //   useEffect(() => {
  //     let lastorderList=[]
  //     returnValue.map((dt, i) => {

  //       lastorderList.push(dt);
  //     });
  //     console.log(lastorderList)

  // //     console.log(returnValue);
  // // setlastorder(returnValue);
  //   }, [returnValue]);
  // useEffect(() => {

  //   newRestaurant.lastOrderTimes= lastOrder;
  //   console.log(lastOrder)
  // }, [lastOrder]);

  //AddSpecification modal open functionality
  const [open, setOpen] = useState(false);

  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [],
  });

  const [logoImg, setlogoImg] = useState<File[]>([]);

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      setlogoImg(filesToUpload);
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };
  console.log(state.selectedImages);
  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages];
    updatedImages.splice(index, 1);
    setState({ selectedImages: updatedImages });
  };

  const [BackgroundImagestate, setBackgroundImagestate] =
    useState<ImageUploadState>({
      selectedImages: [],
    });
  const [backgroundImg, setBackgroundImg] = useState<File[]>([]);

  const handleBackgroundImageUpload = (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - BackgroundImagestate.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);

      const updatedFiles = [...backgroundImg, ...filesToUpload];
      setBackgroundImg(updatedFiles);

      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const validImageTypes = [
          "image/gif",
          "image/avif",
          "image/webp",
          "image/png",
          "image/jpeg",
        ];

        if (validImageTypes.includes(file.type)) {
          const reader = new FileReader();
          reader.onloadend = () => {
            imagesArray.push(reader.result as string);
            if (imagesArray.length === filesToUpload.length) {
              const updatedImages = [
                ...BackgroundImagestate.selectedImages,
                ...imagesArray,
              ];
              setBackgroundImagestate({ selectedImages: updatedImages });
              console.log(BackgroundImagestate.selectedImages);
            }
          };
          reader.readAsDataURL(file);
        } else {
          alert(
            "Please select an image with one of these extensions: GIF, AVIF, WEBP, PNG, JPEG",
          );
        }
      }
    }
  };

  // const handleBackgroundDeleteImage = (index: number) => {
  //     const updatedImages = [...BackgroundImagestate.selectedImages];
  //     updatedImages.splice(index, 1);
  //     setBackgroundImagestate({ selectedImages: updatedImages });
  //     setDeleteBackgroundImagestate(prevIndices=> prevIndices.filter(idx=>idx!==index));
  // }
  const handleBackgroundDeleteImage = (index: number) => {
    const updatedImages = BackgroundImagestate.selectedImages.filter(
      (_, idx) => idx !== index,
    );
    setBackgroundImagestate({ selectedImages: updatedImages });
  };

  const [PremisesImagestate, setPremisesImagestate] =
    useState<ImageUploadState>({
      selectedImages: [],
    });
  const [PremisesImg, setPremisesImg] = useState<File[]>([]);

  const handlePremisesImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    console.log(PremisesImg);
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - PremisesImagestate.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      var obj = PremisesImg;
      obj.push(files[0]);
      setPremisesImg(obj);
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [
              ...PremisesImagestate.selectedImages,
              ...imagesArray,
            ];
            setPremisesImagestate({ selectedImages: updatedImages });
            console.log(PremisesImagestate.selectedImages);
          }
        };
        reader.readAsDataURL(file);
      }
      console.log(imagesArray);
    }
  };

  const handlePremisesDeleteImage = (index: number) => {
    const updatedImages = [...PremisesImagestate.selectedImages];
    updatedImages.splice(index, 1);
    PremisesImg.splice(index, 1);
    setPremisesImagestate({ selectedImages: updatedImages });
  };

  const handleClose = () => {
    props.onHandleAddItem(false);
    setopenConfirmaitonModal(false);
  };

  const [IsCheckManager, setIsCheckManager] = useState(false);
  const handleCloseManager = () => {
    //props.onHandleAddItem(false)
    if (IsCheckManager == true) {
      setIsCheckManager(false);
    } else {
      setIsCheckManager(true);
    }
    setopenConfirmaitonModalManager(false);
  };
  const [autoCompleteValue, setAutoCompleteValue] = React.useState();
  const [parentRestaurant, setParentRestaurant] = React.useState();
  const [Schedule, setSchedule] = React.useState([]);

  const [tokenData, setTokenData] = React.useState({
    UserName: "",
    UserId: "",
  });

  const apiAddress = process.env.REACT_APP_SECRET;
  const ParentRestaurant = JSON.parse(
    localStorage.getItem("parentrestaurant") || "{}",
  );
  const loadManagerData = () => {
    axios
      .get(
        apiAddress +
          "/api/RestaurantUserMapper/GetAllEmployeeByParentRestaurant?restaurantId=" +
          ParentRestaurant.id,
      )
      .then((response) => {
        console.log(response.data);

        // Group data by user ID
        const groupedData = {};
        response.data.forEach((dt) => {
          if (!groupedData[dt.id]) {
            groupedData[dt.id] = {
              id: dt.id,
              fullName: dt.fullName,
              roles: [],
              restaurants: [],
            };
          }

          // Add role if not already present
          if (!groupedData[dt.id].roles.includes(dt.role)) {
            groupedData[dt.id].roles.push(dt.role);
          }

          // Add restaurant if not already present
          if (!groupedData[dt.id].restaurants.includes(dt.restaurantName)) {
            groupedData[dt.id].restaurants.push(dt.restaurantName);
          }
        });

        // Convert grouped data to list format
        var list = [];
        Object.values(groupedData).forEach((user: any) => {
          // Sort roles in priority order: SuperAdmin, GM, LocalManager
          const rolePriority = ["SuperAdmin", "GM", "LocalManager"];
          const sortedRoles = user.roles.sort((a: string, b: string) => {
            return rolePriority.indexOf(a) - rolePriority.indexOf(b);
          });

          // Group restaurants by role
          const restaurantsByRole = {};
          response.data.forEach((dt: any) => {
            if (dt.id === user.id) {
              if (!restaurantsByRole[dt.role]) {
                restaurantsByRole[dt.role] = [];
              }
              if (!restaurantsByRole[dt.role].includes(dt.restaurantName)) {
                restaurantsByRole[dt.role].push(dt.restaurantName);
              }
            }
          });

          // Create display text for restaurants by role
          const restaurantDisplay = sortedRoles
            .map((role) => {
              const restaurants = restaurantsByRole[role] || [];
              return restaurants.length > 0
                ? `${role}'s Restaurant${restaurants.length > 1 ? "s" : ""}: ${restaurants.join(", ")}`
                : "";
            })
            .filter((text) => text !== "")
            .join(" | ");

          var obj = {
            id: user.id,
            title: user.fullName,
            role: sortedRoles.join(", "), // Keep role for badge display
            restaurant: restaurantDisplay, // Grouped restaurants by role
            roles: sortedRoles,
            restaurants: user.restaurants,
            displayText: `${user.fullName}          ${sortedRoles.join(", ")}`,
            displayRestaurants: restaurantDisplay,
          };
          list.push(obj);
        });

        setManagerDatas(list);
      });
  };

  const loadData = () => {
    axios
      .get(apiAddress + "/api/FoodCategory/getFoodCategory")
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.categoryName,
          };
          list.push(obj);
        });
        setsectionDatas(list);
      });

    const token = localStorage.getItem("gotasteadmintoken");

    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
        var list = [];
        list.push(obj);
        // setManagerDatas(list);
      } catch (error) {}
    }
    axios
      .get(
        apiAddress +
          "/api/Restaurant/getrestaurantdetailsbyid/" +
          decodedData.RestaurantId,
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        list.push(response.data);
        setRestaurantDatas(list);
      });
  };

  useEffect(() => {
    loadData();
    loadManagerData();
  }, []);

  const [sectionDatas, setsectionDatas] = useState([]);
  const [ManagerDatas, setManagerDatas] = useState([]);
  // Replace single manager state with multiple
  const [selectedManagers, setSelectedManagers] = useState([]);

  const [restaurantDatas, setRestaurantDatas] = useState([]);

  const [providedFoodDatas, setProvidedFoodDatas] = useState([]);

  // Handle manager selection change with validation
  const handleManagerSelectionChange = (event, newValue) => {
    // Get current restaurant name from the form
    const currentRestaurantName = newRestaurant.Restaurantname;
    console.log("Current restaurant name:", currentRestaurantName);

    // Check for managers with higher roles specifically for the current restaurant
    const invalidManagers = newValue.filter((manager) => {
      // Get the manager's role specifically for the current restaurant
      const currentRestaurantRole = manager.roles?.find((role, index) => {
        const higherRoles = ["Owner", "SuperAdmin", "Admin", "GM"];
        // Check if this role is a higher role AND if the corresponding restaurant matches current restaurant
        if (higherRoles.includes(role)) {
          const restaurantForThisRole = manager.restaurants?.[index];
          return (
            restaurantForThisRole &&
            restaurantForThisRole
              .toLowerCase()
              .includes(currentRestaurantName?.toLowerCase() || "")
          );
        }
        return false;
      });

      // Block if they have a higher role specifically for the current restaurant
      return currentRestaurantRole !== undefined;
    });

    if (invalidManagers.length > 0) {
      // Show toast message for invalid selections with specific roles
      const invalidManagerDetails = invalidManagers
        .map((manager) => {
          // Find the specific higher role for the current restaurant
          const currentRestaurantRole = manager.roles?.find((role, index) => {
            const higherRoles = ["Owner", "SuperAdmin", "Admin", "GM"];
            if (higherRoles.includes(role)) {
              const restaurantForThisRole = manager.restaurants?.[index];
              return (
                restaurantForThisRole &&
                restaurantForThisRole
                  .toLowerCase()
                  .includes(currentRestaurantName?.toLowerCase() || "")
              );
            }
            return false;
          });

          return `${manager.title} already has a ${currentRestaurantRole || "Unknown"} role`;
        })
        .join(", ");

      toast.error(
        `${invalidManagerDetails} for this restaurant. Please select other managers.`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        },
      );

      // Filter out invalid managers from the selection
      const validManagers = newValue.filter(
        (manager) => !invalidManagers.includes(manager),
      );
      setSelectedManagers(validManagers);
    } else {
      // All selections are valid
      setSelectedManagers(newValue);
    }
  };

  const addValue = (props) => {
    console.log(props);
    var obj = ManagerDatas.find((x) => x.title == props);
    setAutoCompleteValue(obj);
  };

  console.log(selectedManagers);

  const addProvidedFoodValue = (event, newvalue) => {
    console.log(newvalue);
    var list = [];
    newvalue.map((dt, i) => {
      sectionDatas?.map((d, i) => {
        if (d.title == dt) {
          var obj = {
            id: d.id,
            title: dt,
          };
          list.push(obj);
        }
      });
    });
    setProvidedFoodDatas(list);
  };

  const addParentRestaurant = (props) => {
    console.log(props);
    if (props != "") {
      var obj = restaurantDatas.find((x) => x.title == props);
      setParentRestaurant(obj.id);
      console.log(obj.id);
      newRestaurant.ParentRestaurant = obj.id;
    } else {
      setParentRestaurant();
      newRestaurant.ParentRestaurant = "";
    }
  };
  const getSchedule = (props) => {
    console.log(props);
    setSchedule(props);
  };

  const [radiovalue, setRadioValue] = React.useState("Specify");

  const [phoneNumber, SetPhoneNumber] = useState();
  const [validPhoneNumber, SetvalidPhoneNumber] = useState(true);
  const [newRestaurant, setNewRestaurant] = useState({
    Restaurantname: "",
    UrlName: "",
    AddressLine1: "",
    Latitude: null,
    Longitude: null,
    AddressLine2: "",
    City: "",
    PostCode: "",
    Email: "",
    PhoneNumber: phoneNumber,
    ProvidedFoodCategory: "",
    isMemberOfChain: isChain,
    Details: "",
    ParentRestaurant: parentRestaurant,
    Logo: "",
    BakcgroundImage: "",
    PremisesImage: "",
    ServiceCahrge: "",
    HygeneRating: "",
    CreatorId: tokenData.UserId,
    homePageTexts: [
      {
        id: "string",
        restaurantId: "string",
        text: "string",
        isActive: true,
        rank: 0,
        creatorId: "string",
        creationDate: "2023-09-11T04:41:54.979Z",
        modifierId: "string",
        modificationDate: "2023-09-11T04:41:54.979Z",
      },
    ],
  });

  const phoneNumberValue = (props) => {
    console.log(props);
    try {
      var test = props / 1;
      if (isNaN(test)) {
        var empty = "";
        SetvalidPhoneNumber(false);
        SetPhoneNumber(empty);
        newRestaurant.PhoneNumber = empty;
      } else {
        if (props.length <= 11) {
          SetvalidPhoneNumber(true);
          SetPhoneNumber(props);
          newRestaurant.PhoneNumber = props;
        } else {
          return;
        }
      }
    } catch {
      console.log("Error");
    }
  };
  const testsubmit = () => {
    SetsaveClicked("Saving");

    console.log(lastOrderTime);
    if (lastOrderTime.length > 0) {
      SetsaveClicked("return");
    }

    console.log(saveClicked);
  };

  const submit = () => {
    //SetsaveClicked("Saving")

    var valid = true;
    var listOfTypewriterTexts = [];
    if (!urlnameSuccess) {
      valid = false;
      toast.error("Select Url Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (phoneNumber?.length != 10 && phoneNumber?.length != 11) {
      valid = false;
      toast.error("Phone number is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (selectedtypewriterTextList.length == 0) {
      valid = false;
      toast.error("Typewriter list is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      selectedtypewriterTextList.map((dt, i) => {
        var obj = {
          id: "string",
          restaurantId: "string",
          text: dt.name,
          isActive: true,
          rank: dt.rank,
          creatorId: tokenData.UserId,
          creationDate: "2023-09-11T04:41:54.979Z",
          modifierId: tokenData.UserId,
          modificationDate: "2023-09-11T04:41:54.979Z",
        };
        listOfTypewriterTexts.push(obj);
        newRestaurant.homePageTexts = listOfTypewriterTexts;
      });
    }
    if (
      newRestaurant.Restaurantname == "" ||
      newRestaurant.Restaurantname == undefined ||
      newRestaurant.Restaurantname == null
    ) {
      valid = false;
      toast.error("Restaurant name is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      newRestaurant.AddressLine1 == "" ||
      newRestaurant.AddressLine1 == undefined ||
      newRestaurant.AddressLine1 == null
    ) {
      valid = false;
      toast.error("Address Line 1 is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    // City field Validation
    if (
      newRestaurant.City == "" ||
      newRestaurant.City == undefined ||
      newRestaurant.City == null
    ) {
      valid = false;
      toast.error("City is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    // if (autoCompleteValue == undefined || autoCompleteValue == null) {
    //   valid = false;
    //   toast.error("Manager is not valid", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    // }
    if (
      newRestaurant.PostCode == "" ||
      newRestaurant.PostCode == undefined ||
      newRestaurant.PostCode == null
    ) {
      valid = false;
      toast.error("Post Code is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      newRestaurant.Email == "" ||
      newRestaurant.Email == undefined ||
      newRestaurant.Email == null ||
      !newRestaurant.Email.includes("@")
    ) {
      valid = false;
      toast.error("Email is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      newRestaurant.PhoneNumber == "" ||
      newRestaurant.PhoneNumber == undefined ||
      newRestaurant.PhoneNumber == null
    ) {
      valid = false;
      toast.error("Phone Number is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      providedFoodDatas.length == 0 ||
      providedFoodDatas == undefined ||
      providedFoodDatas == null
    ) {
      valid = false;
      toast.error("Provided Food Category is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    // if (isChain) {
    //     if (parentRestaurant == "" || parentRestaurant == undefined || parentRestaurant == null) {
    //         valid = false;
    //         toast.error("Parent Restaurant is not valid", {
    //             position: "top-right",
    //             autoClose: 5000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //             theme: "colored",
    //         });
    //     }
    // }
    // else {
    //     newRestaurant.ParentRestaurant = "Nothing selected";
    // }
    if (
      newRestaurant.Details == "" ||
      newRestaurant.Details == undefined ||
      newRestaurant.Details == null
    ) {
      valid = false;
      toast.error("Details is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    // if (newRestaurant.ServiceCahrge == "" || newRestaurant.ServiceCahrge == undefined || newRestaurant.ServiceCahrge == null) {
    //     valid = false;
    //     toast.error("Service Charge is not valid", {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored",
    //     });
    // }
    if (
      newRestaurant.HygeneRating == "" ||
      newRestaurant.HygeneRating == undefined ||
      newRestaurant.HygeneRating == null
    ) {
      valid = false;
      toast.error("Hygene Rating is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      PremisesImg.length == 0 ||
      PremisesImg == undefined ||
      PremisesImg == null
    ) {
      valid = false;
      toast.error("Premises Image is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (
      backgroundImg.length == 0 ||
      backgroundImg == undefined ||
      backgroundImg == null
    ) {
      valid = false;
      toast.error("Background Image is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (logoImg.length == 0 || logoImg == undefined || logoImg == null) {
      valid = false;
      toast.error("Logo Image is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (Schedule.length == 0 || Schedule == undefined || Schedule == null) {
      valid = false;
      toast.error("Schedule is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    // Validate last order time
    // if (
    //   lastOrderTime.length === 0 ||
    //   lastOrderTime.some((item) => !item.LastOrderTime)
    // ) {
    //   valid = false;
    //   toast.error("Please Confirm Last order times in scheduler", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    // }

    var restaurantDetails = JSON.parse(localStorage.getItem("restaurant"));
    newRestaurant.ParentRestaurant = restaurantDetails.id;
    if (valid) {
      //SetloadingModal(true);
      logoUpload();
      // postData();
    }
  };

  const logoUpload = async () => {
    const formData = new FormData();
    formData.append("file", logoImg[0]);
    await axios({
      method: "post",
      url: apiAddress + "/api/FileUpload/addfile",
      headers: {
        "Content-Type": "multipart/form-data", // <- HERE
      },
      data: formData,
    })
      .then((response) => {
        console.log(response);
        newRestaurant.Logo = response.data.url;
        backgroundUpload();
      })
      .catch((error) => {
        console.log(error);
        SetloadingModal(false);
      });
  };

  const backgroundUpload = async () => {
    const formData = new FormData();
    formData.append("file", backgroundImg[0]);
    await axios({
      method: "post",
      url: apiAddress + "/api/FileUpload/addfile",
      headers: {
        "Content-Type": "multipart/form-data", // <- HERE
      },
      data: formData,
    })
      .then((response) => {
        console.log(response);
        newRestaurant.BakcgroundImage = response.data.url;
        premisesUpload();
      })
      .catch((error) => {
        console.log(error);
        SetloadingModal(false);
      });
  };
  const premisesUpload = async () => {
    const formData = new FormData();
    PremisesImg.forEach((file) => {
      formData.append("file", file);
    });
    await axios({
      method: "post",
      url: apiAddress + "/api/FileUpload/addMultiplefile",
      headers: {
        "Content-Type": "multipart/form-data", // <- HERE
      },
      data: formData,
    })
      .then((response) => {
        console.log(response);
        newRestaurant.PremisesImage = response.data;
        console.log("Premises image uploaded");
        postData();
      })
      .catch((error) => {
        console.log(error);
        SetloadingModal(false);
      });
  };
  //postData();

  const postData = async () => {
    //alert("On Pst");
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        setTokenData(decodedData);
        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
        var list = [];
        list.push(obj);
        setManagerDatas(list);
      } catch (error) {}
    }
    newRestaurant.providedFoodCategories = providedFoodDatas;
    newRestaurant.scheduler = Schedule;
    newRestaurant.isPetFriendly = switchCheck;
    // Send the full manager objects as expected by the backend
    newRestaurant.managerName = selectedManagers;
    newRestaurant.CreatorId = decodedData.UserId;
    newRestaurant.lastOrderTimes = lastOrderTime;
    newRestaurant.IsPreview = Preview;
    newRestaurant.IsHomeCook = HomeCook;
    newRestaurant.isDelivery = DeliveryswitchCheck;
    newRestaurant.isCollectionOnly = CollectionswitchCheck;
    newRestaurant.isDeliveryOnly = DeliveryOnlyswitchCheck;
    newRestaurant.wifiSSID = wifiSSID;
    newRestaurant.wifiPassword = wifiPassWord;
    newRestaurant.isServiceChargeCompulsory = serviceChargeCompulsoryCheck;

    let webLinkList = [];
    selectedWebLinksList.map((link) => {
      var links = {
        id: "string",
        restaurntId: "string",
        text: link.name,
        creatorId: tokenData.UserId,
      };

      webLinkList.push(links);
    });
    newRestaurant.webLinks = webLinkList ?? [];

    let spotifylist = [];

    selectedSpotifyLinksList.map((dt, i) => {
      var obj = {
        id: "string",
        restaurantId: "string",
        text: dt.name,
        creatorId: tokenData.UserId,
      };
      spotifylist.push(obj);
    });
    newRestaurant.spotifyLinks = spotifylist ?? [];

    console.log(newRestaurant);
    // await axios({
    //   method: "post",
    //   url: apiAddress + "/api/Restaurant/postnewrestaurant",
    //   data: newRestaurant,
    // })
    SetloadingModal(true);
    axios
      .post(apiAddress + "/api/Restaurant/postnewrestaurant", newRestaurant)
      .then((response) => {
        console.log(response);
        var obj = {
          Restaurantname: "",
          AddressLine1: "",
          AddressLine2: "",
          PostCode: "",
          Email: "",
          PhoneNumber: "",
          ProvidedFoodCategory: "",
          isMemberOfChain: "",
          Details: "",
          ParentRestaurant: "",
          Logo: "",
          BakcgroundImage: "",
          PremisesImage: "",
          ServiceCahrge: "",
          HygeneRating: "",
          CreatorId: tokenData.UserId,
          WifiSSID: "",
          WifiPassWord: "",
        };
        setNewRestaurant(obj);
        setProvidedFoodDatas([]);
        setSchedule([]);
        setSelectedManagers([]);
        SetloadingModal(false);
        toast.success("Successfully saved", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        window.location.href = "/restaurant-setup";
      })
      .catch((error) => {
        console.log(error);
        SetloadingModal(false);
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  const [loadingModal, SetloadingModal] = React.useState(false);
  const [typewriterText, SettypewriterText] = React.useState("");
  const [typewriterTextList, SettypewriterTextList] = React.useState([]);
  const [temptypewriterTextList, SettemptypewriterTextList] = React.useState(
    [],
  );
  const [selectedtypewriterTextList, SetselectedtypewriterTextList] =
    React.useState([]);
  const closeLoadingModal = () => {
    SetloadingModal(false);
  };
  useEffect(() => {
    SettypewriterTextList(temptypewriterTextList);
  }, [typewriterTextList]);

  const addtoTypewriterList = () => {
    var obj = {
      name: typewriterText,
    };
    var list = typewriterTextList;
    list.push(obj);
    SettemptypewriterTextList(list);
    SettypewriterTextList([]);
    SettypewriterText("");
  };

  const getTypeWriterData = (props) => {
    SetselectedtypewriterTextList(props);
  };

  const [loadingUrlCheck, setLoadingUrlCheck] = useState(false);
  const [urlnameSuccess, seturlnameSuccess] = useState(false);
  const [onUrlClick, setonUrlClick] = useState(false);
  const [urlName, setUrlName] = useState("");
  const checkUrlName = (props) => {
    // SetselectedtypewriterTextList(props)
    var res = props.includes(" ");
    // setUrlName()
    if (res) {
      toast.error("Space is not allowed", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      setUrlName(props);
      setonUrlClick(false);
      seturlnameSuccess(false);
      if (props != "") {
        setLoadingUrlCheck(true);
        setonUrlClick(true);
        axios({
          method: "get",
          url: apiAddress + "/api/Restaurant/checkurlname?urlName=" + props,
        })
          .then((response) => {
            console.log(response.data);
            setLoadingUrlCheck(false);
            if (response.data == true) {
              newRestaurant.UrlName = props;
              seturlnameSuccess(true);
            } else {
              seturlnameSuccess(false);
            }
          })
          .catch((error) => {
            setLoadingUrlCheck(false);
          });
      }
    }
  };

  const handleSwitchChange = (props) => {
    setswitchCheck(!switchCheck);
  };

  //tooltip start
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default Enter key action

      const inputValue = event.target.value.trim();
      if (
        inputValue &&
        !sectionDatas.some((option) => option.title === inputValue)
      ) {
        // Add the new value to the array
        setsectionDatas([...sectionDatas, { id: "", title: inputValue }]);
      }

      // Clear the input field
      event.target.value = "";
    }
  };

  const [DeliveryswitchCheck, setDeliveryswitchCheck] = useState(false);
  const [CollectionswitchCheck, setCollectionswitchCheck] = useState(false);
  const [DeliveryOnlyswitchCheck, setDeliveryOnlyswitchCheck] = useState(false);
  const [CollectionDisabled, setCollectionDisabled] = useState(true);
  const [Preview, setPreview] = useState(ParentRestaurant.ulsHLfS || false);
  const [HomeCook, setHomeCook] = useState(ParentRestaurant.ulsHLfS || false);

  const handlePreviewSwitchChange = (props) => {
    if (Preview == false) {
      setPreview(true);
      //setCollectionswitchCheck(true)
    } else {
      setPreview(false);
      //setCollectionswitchCheck(false)
    }
  };

  const handleHomeCookSwitchChange = (props) => {
    if (HomeCook == false) {
      setHomeCook(true);
    } else {
      setHomeCook(false);
      //setCollectionswitchCheck(false)
    }
  };

  const handleDeliverySwitchChange = (props) => {
    if (DeliveryswitchCheck == false) {
      setDeliveryswitchCheck(true);
      //setCollectionswitchCheck(true)
    } else {
      setDeliveryswitchCheck(false);
      //setCollectionswitchCheck(false)
    }
  };

  const handleDeliveryOnlySwitchChange = (props) => {
    if (DeliveryOnlyswitchCheck == false) {
      setDeliveryOnlyswitchCheck(true);
      //setCollectionswitchCheck(true)
    } else {
      setDeliveryOnlyswitchCheck(false);
      //setCollectionswitchCheck(false)
    }
  };

  const handleCollectionSwitchChange = (props) => {
    if (CollectionswitchCheck == false) {
      //setDeliveryswitchCheck(true)
      setCollectionswitchCheck(true);
    } else {
      //setDeliveryswitchCheck(false)
      setCollectionswitchCheck(false);
    }
  };

  const [serviceChargeCompulsoryCheck, setserviceChargeCompulsoryCheck] =
    useState(false);

  const handleServiceChargeCompulsoryCheck = (props) => {
    if (serviceChargeCompulsoryCheck == false) {
      setserviceChargeCompulsoryCheck(true);
    } else {
      setserviceChargeCompulsoryCheck(false);
    }
  };

  const [wifiCheck, setwifiCheck] = useState(false);
  const [wifiPublicCheck, setwifiPublicCheck] = useState(false);
  const [wifiSSID, setwifiSSID] = useState("");
  const [wifiPassWord, setwifiPassWord] = useState("");

  const handleWifiCheck = (props) => {
    if (wifiCheck == false) {
      setwifiCheck(true);
    } else {
      setwifiCheck(false);
      setwifiSSID("");
      setwifiPassWord("");
    }
  };
  const handleWifiPublicCheck = (props) => {
    if (wifiPublicCheck == false) {
      setwifiPublicCheck(true);
    } else {
      setwifiPublicCheck(false);
    }
  };

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  const [spotifyLink, SetspotifyLink] = React.useState("");
  const [spotifyLinkList, SetspotifyLinkList] = React.useState([]);
  const [tempspotifyLinkList, SettempspotifyLinkList] = React.useState([]);

  const addtoSpotifyLinksList = () => {
    var obj = {
      name: spotifyLink,
    };
    var list = spotifyLinkList;
    list.push(obj);
    SettempspotifyLinkList(list);
    SetspotifyLinkList([]);
    SetspotifyLink("");
  };

  useEffect(() => {
    SetspotifyLinkList(tempspotifyLinkList);
  }, [spotifyLinkList]);

  const [selectedSpotifyLinksList, SetselectedSpotifyLinksList] =
    React.useState([]);

  const getSpotifyData = (props) => {
    SetselectedSpotifyLinksList(props);
  };

  const [webLink, SetWebLink] = React.useState("");
  const [webLinkList, SetwebLinkList] = React.useState([]);
  const [tempWebLinkList, SetTempWebLinkList] = React.useState([]);

  const addWebLink = () => {
    const urlPattern =
      /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})(\/[\w \.-]*)*\/?$/;

    if (!urlPattern.test(webLink)) {
      toast.error("Please enter a valid URL.");
      return;
    }

    var obj = {
      name: webLink,
    };
    var list = webLinkList;
    list.push(obj);
    SetTempWebLinkList(list);
    SetwebLinkList([]);
    SetWebLink("");
  };

  useEffect(() => {
    SetwebLinkList(tempWebLinkList);
  }, [webLinkList]);

  useEffect(() => {
    console.log(selectedSpotifyLinksList);
  }, [selectedSpotifyLinksList]);

  const [selectedWebLinksList, SetselectedWebLinksList] = React.useState([]);

  const getWebLinkData = (props) => {
    SetselectedWebLinksList(props);
  };

  const [saveClicked, SetsaveClicked] = React.useState("");

  //tooltip end
  return (
    <>
      <div>
        <React.Fragment>
          <Dialog
            fullWidth={true}
            maxWidth={"xl"}
            open={restaurantModalOpen}
            // onClose={handleClose}
          >
            <SweetAlertModal
              headerText={"Do you want to leave without saving?"}
              bodyText={"All changes made will be lost"}
              open={openConfirmaitonModal}
              onyes={handleClose}
              close={() => {
                setopenConfirmaitonModal(false);
              }}
              id={2}
            />
            <SweetAlertModal
              headerText={"Are You Sure?"}
              bodyText={
                <div style={{ textAlign: "center" }}>
                  General Managers can add restaurants, edit all restaurants and
                  all menus on this account
                </div>
              }
              open={openConfirmaitonModalManager}
              onyes={handleCloseManager}
              close={() => {
                setopenConfirmaitonModalManager(false);
              }}
            />
            <Grid container>
              <Grid item xs={6}>
                <DialogTitle>Add New Restaurant</DialogTitle>
              </Grid>
              <Grid item xs={6}>
                <DialogActions>
                  <Button onClick={() => setopenConfirmaitonModal(true)}>
                    <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                  </Button>
                </DialogActions>
              </Grid>
            </Grid>

            <DialogContent>
              <ToastContainer />
              <LoadingView open={loadingModal} close={closeLoadingModal} />

              <div style={{ padding: "10px" }}>
                {/* Name Field */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>Name</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Restaurant name"}
                      value={(props) => {
                        newRestaurant.Restaurantname = props;
                      }}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                {/* Url Name */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Url Name
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Url name"}
                      value={(props) => {
                        checkUrlName(props);
                        // newRestaurant.Restaurantname = props;
                      }}
                      val={urlName}
                    ></TextAreaComponents>
                    {loadingUrlCheck ? (
                      <img
                        src={loading}
                        alt="Loading"
                        style={{ width: "1rem" }}
                      />
                    ) : (
                      ""
                    )}
                    {onUrlClick ? (
                      urlnameSuccess ? (
                        <span style={{ color: "#2ECC71" }}>
                          Url Name Available
                        </span>
                      ) : (
                        <span style={{ color: "#E74C3C" }}>
                          Url Name Not Available
                        </span>
                      )
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                {/* Address Line 1 */}
                <Grid
                  container
                  sx={{ padding: "0.5rem" }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Grid item xs={2}>
                    <Typography>Address Line 1</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {isLoaded ? (
                      // <GooglePlacesAutocomplete
                      //   onLoad={(autocomplete) =>
                      //     (autocompleteRef.current = autocomplete)
                      //   }
                      //   onPlaceChanged={() => {
                      //     const place = autocompleteRef.current?.getPlace();
                      //     if (!place) {
                      //       console.warn(
                      //         "⚠️ No place returned from Google Places",
                      //       );
                      //       return;
                      //     }

                      //     console.log("📍 Full place object:", place);

                      //     const addr = place.formatted_address || "";
                      //     setSelectedAddress(addr);

                      //     const location = place.geometry?.location;
                      //     const lat = location ? location.lat() : null;
                      //     const lng = location ? location.lng() : null;

                      //     setNewRestaurant((prev) => ({
                      //       ...prev,
                      //       AddressLine1: addr,
                      //       Latitude: lat,
                      //       Longitude: lng,
                      //     }));

                      //     const components = place.address_components || [];
                      //     console.log("🧱 address_components:", components);

                      //     const postcode = components
                      //       .find((c) => c.types.includes("postal_code"))
                      //       ?.short_name?.trim();
                      //     const city =
                      //       components
                      //         .find((c) => c.types.includes("locality"))
                      //         ?.long_name?.trim() ||
                      //       components
                      //         .find((c) => c.types.includes("postal_town"))
                      //         ?.long_name?.trim() ||
                      //       components
                      //         .find((c) =>
                      //           c.types.includes("administrative_area_level_2"),
                      //         )
                      //         ?.long_name?.trim();

                      //     if (postcode) {
                      //       newRestaurant.PostCode = postcode;
                      //       console.log("📬 Postcode set:", postcode);
                      //     } else {
                      //       console.warn(
                      //         "PostalCodes not found in address components",
                      //       );
                      //     }

                      //     if (city) {
                      //       newRestaurant.City = city;
                      //       console.log("🏙️ City set:", city);
                      //     } else {
                      //       console.warn(
                      //         "City not found in address components",
                      //       );
                      //     }
                      //   }}
                      //   options={{
                      //     componentRestrictions: { country: "gb" },
                      //     fields: [
                      //       "geometry",
                      //       "formatted_address",
                      //       "address_components",
                      //     ],
                      //   }}
                      // >
                      //   <TextField
                      //     label="Address line 1"
                      //     variant="outlined"
                      //     fullWidth
                      //     value={selectedAddress}
                      //     onChange={(e) => {
                      //       const val = e.target.value;
                      //       setSelectedAddress(val);
                      //     }}
                      //     placeholder="Start typing an address..."
                      //   />
                      // </GooglePlacesAutocomplete>

                      <GooglePlacesAutocomplete
                        onLoad={(autocomplete) =>
                          (autocompleteRef.current = autocomplete)
                        }
                        onPlaceChanged={() => {
                          const place = autocompleteRef.current?.getPlace();

                          if (!place) {
                            console.warn(
                              "⚠️ No place returned from Google Places",
                            );
                            return;
                          }

                          console.log("📍 Full place object:", place);

                          const addr = place.formatted_address || "";

                          const location = place.geometry?.location;
                          const lat = location ? location.lat() : null;
                          const lng = location ? location.lng() : null;

                          const components = place.address_components || [];

                          const postcode =
                            components
                              .find((c) => c.types.includes("postal_code"))
                              ?.short_name?.trim() || "";

                          const city =
                            components
                              .find((c) => c.types.includes("locality"))
                              ?.long_name?.trim() ||
                            components
                              .find((c) => c.types.includes("postal_town"))
                              ?.long_name?.trim() ||
                            components
                              .find((c) =>
                                c.types.includes("administrative_area_level_2"),
                              )
                              ?.long_name?.trim() ||
                            "";

                          setSelectedAddress(addr);

                          setNewRestaurant((prev) => ({
                            ...prev,
                            AddressLine1: addr,
                            Latitude: lat,
                            Longitude: lng,
                            PostCode: postcode,
                            City: city,
                          }));
                        }}
                        fields={[
                          "geometry",
                          "formatted_address",
                          "address_components",
                        ]}
                        options={{
                          componentRestrictions: { country: "gb" },
                        }}
                      >
                        <TextField
                          label="Address line 1"
                          variant="outlined"
                          fullWidth
                          value={selectedAddress}
                          onChange={(e) => {
                            setSelectedAddress(e.target.value);
                          }}
                          placeholder="Start typing an address..."
                        />
                      </GooglePlacesAutocomplete>
                    ) : (
                      <TextField
                        label="Address line 1"
                        variant="outlined"
                        value={selectedAddress}
                        fullWidth
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedAddress(val);
                          newRestaurant.AddressLine1 = val;
                        }}
                        InputProps={{
                          endAdornment: <CircularProgress size={20} />,
                        }}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "5px",
                    }}
                  >
                    <Button
                      className="AddItemButtons"
                      onClick={handleOpenAddressModal}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
                {/* Address Line 2 */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Address line 2 (optional)
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Address line 2 (optional)"}
                      value={(props) => {
                        newRestaurant.AddressLine2 = props;
                      }}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                {/* City Field */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>City</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"City"}
                      value={(val) => {
                        setNewRestaurant((prev) => ({ ...prev, City: val }));
                      }}
                      val={newRestaurant.City} // ✅ bind current state → forces field to reflect updates
                    />
                  </Grid>
                </Grid>
                {/* Post Code Field */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Post Code
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    {/* Post Code */}
                    <TextAreaComponents
                      label={"Post Code"}
                      value={(val) => {
                        setNewRestaurant((prev) => ({
                          ...prev,
                          PostCode: val,
                        }));
                      }}
                      val={newRestaurant.PostCode} // ✅ bind current state
                    />
                  </Grid>
                </Grid>
                {/* Email Address Field */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Email Address
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Email Address"}
                      value={(props) => {
                        newRestaurant.Email = props;
                      }}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                {/* Phone Number Field */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Phone Number
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Phone Number"}
                      value={phoneNumberValue}
                      id="3"
                      val={phoneNumber}
                    ></TextAreaComponents>
                    <span
                      className={`${validPhoneNumber ? "d-none" : ""}`}
                      style={{ color: "red" }}
                    >
                      Phone Number is not valid
                    </span>
                  </Grid>
                </Grid>
                {/* Food Category */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Food Category
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    {/* <AutoCompleteMultiSelect
                                            label={'Type Of Restaurant'}
                                            placeholder={'Type Of Restaurant'}
                                            value={addProvidedFoodValue}
                                            datas={sectionDatas}
                                        /> */}

                    <Autocomplete
                      multiple
                      id="free-solo-with-text-demo"
                      options={sectionDatas?.map((option) => option.title)}
                      freeSolo
                      onChange={addProvidedFoodValue}
                      disableClearable={providedFoodDatas.length >= 5}
                      renderTags={(value: readonly string[], getTagProps) =>
                        value.map((option: string, index: number) => (
                          <Chip
                            variant="outlined"
                            label={option}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            pointerEvents:
                              providedFoodDatas.length >= 5 ? "none" : "auto",
                          }}
                        >
                          {option}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={"Keywords"}
                          onKeyDown={handleKeyDown}
                        />
                      )}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    className="AddItemplusIcon"
                    onClick={() => setOpenAddSection(true)}
                  >
                    <img src={plusIcon} alt="+" />
                  </Grid>
                  <AddFoodCategoryDialog
                    open={openAddSection}
                    dialogType={dialogType}
                    onHandleAddItem={handleOpenFoodCategory}
                    isSubmitting={isSubmitting}
                    setIsSubmitting={setIsSubmitting}
                    onClose={() => {
                      loadData();
                    }}
                  />
                </Grid>
                {/* <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Is member of a chain?
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Switch
                                            checked={isChain}
                                            onChange={() => { setisChain(!isChain) }}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    </Grid>
                                </Grid>
                                {isChain && (
                                    <Grid container sx={{ padding: '0.5rem' }}>
                                        <Grid item xs={2}></Grid>
                                        <Grid item xs={10}>
                                            <AutoCompleteMultiSelect
                                                label={'Parent Restaurant Name'}
                                                placeholder={'Parent Restaurant Name'}
                                                value={addParentRestaurant}
                                                datas={restaurantDatas}
                                                id={1}
                                            />

                                        </Grid>

                                    </Grid>
                                )} */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Details
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      id={1}
                      label={"Details"}
                      value={(props) => {
                        newRestaurant.Details = props;
                      }}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={12}>
                    <SchedulerComponent
                      from="discount"
                      getSchedule={getSchedule}
                      getLastOrderTimeList={getLastOrderTime}
                      resSaveClicked={saveClicked}
                      showSchedulerTable={true}
                      showLastOrderTime={true}
                    />
                  </Grid>
                </Grid>
                {/* Adding SchedularPreview component after SchedulerComponent */}
                {/* <Schedulepreviwdialog
                  onConfirm={handleConfirmLastOrderTimes}  // Pass the handler to SchedularPreview
                  selectedId={selectedSchedularObj.map(schedule => schedule.id)} // Extract IDs from selectedSchedularObj
                /> */}
                {/* <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Closing hour
                                    </Typography>
                                </Grid>
                                <Grid item xs={10}>
                                    <input type="time" id="appt" name="appt" />
                                </Grid>
                            </Grid> */}
                {/* <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Is Open
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Switch
                                        checked={switchCheck}
                                        onChange={handleSwitchChange}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Grid>
                            </Grid> */}
                {/* <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Owner Name
                                    </Typography>
                                </Grid>
                                <Grid xs={10}>
                                    <TextAreaComponents label={'Owner Name'} value={textFieldValue} />
                                </Grid>
                            </Grid> */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Local Manager
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <div className="d-flex w-100" style={{ gap: "10px" }}>
                      <div className="" style={{ width: "60rem" }}>
                        {(() => {
                          if (ManagerDatas && ManagerDatas.length > 0) {
                            return (
                              <Autocomplete
                                multiple
                                options={ManagerDatas}
                                getOptionLabel={(option) => option?.title || ""}
                                value={selectedManagers}
                                onChange={(event, newValue) =>
                                  handleManagerSelectionChange(event, newValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Manager Name"
                                    placeholder="Manager Name"
                                    variant="outlined"
                                  />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option?.id === value?.id
                                }
                                id="manager-autocomplete"
                                renderOption={(props, option) => (
                                  <Box
                                    component="li"
                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                    {...props}
                                  >
                                    <img
                                      loading="lazy"
                                      src={img1}
                                      alt=""
                                      style={{ width: "2rem" }}
                                    />
                                    <div
                                      className="d-flex "
                                      style={{ flexDirection: "column" }}
                                    >
                                      <div
                                        className="d-flex"
                                        style={{
                                          gap: "10px",
                                          alignItems: "center",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <h5
                                          className="mb-0"
                                          style={{ margin: 0 }}
                                        >
                                          {option.title}
                                        </h5>
                                        {option.roles &&
                                          option.roles.map((role, index) => (
                                            <React.Fragment key={index}>
                                              <div
                                                style={{
                                                  backgroundColor: "#fde6ea",
                                                  padding: "5px",
                                                  fontSize: ".8rem",
                                                  borderRadius: "10px",
                                                  color: "#847c7d",
                                                }}
                                              >
                                                {role}
                                              </div>
                                              {index <
                                                option.roles.length - 1 && (
                                                <span
                                                  style={{
                                                    color: "#847c7d",
                                                    fontSize: ".8rem",
                                                  }}
                                                >
                                                  |
                                                </span>
                                              )}
                                            </React.Fragment>
                                          ))}
                                      </div>
                                      <span
                                        className="text-muted"
                                        style={{
                                          fontSize: "1rem",
                                          marginTop: "0",
                                        }}
                                      >
                                        {option.restaurant}
                                      </span>
                                    </div>
                                  </Box>
                                )}
                              />
                            );
                          } else {
                            return (
                              <Autocomplete
                                options={ManagerDatas}
                                getOptionLabel={(option) => option.title || ""}
                                value={selectedManagers}
                                onChange={(event, newValue) =>
                                  handleManagerSelectionChange(event, newValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Manager Name"
                                    placeholder="Manager Name"
                                    variant="outlined"
                                  />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                id="manager-autocomplete"
                                renderOption={(props, option) => (
                                  <Box
                                    component="li"
                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                    {...props}
                                  >
                                    <img
                                      loading="lazy"
                                      src={img1}
                                      alt=""
                                      style={{ width: "2rem" }}
                                    />
                                    <div
                                      className="d-flex "
                                      style={{ flexDirection: "column" }}
                                    >
                                      <div
                                        className="d-flex"
                                        style={{
                                          gap: "10px",
                                          alignItems: "center",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <h5
                                          className="mb-0"
                                          style={{ margin: 0 }}
                                        >
                                          {option.title}
                                        </h5>
                                        {option.roles &&
                                          option.roles.map((role, index) => (
                                            <React.Fragment key={index}>
                                              <div
                                                style={{
                                                  backgroundColor: "#fde6ea",
                                                  padding: "5px",
                                                  fontSize: ".8rem",
                                                  borderRadius: "10px",
                                                  color: "#847c7d",
                                                }}
                                              >
                                                {role}
                                              </div>
                                              {index <
                                                option.roles.length - 1 && (
                                                <span
                                                  style={{
                                                    color: "#847c7d",
                                                    fontSize: ".8rem",
                                                  }}
                                                >
                                                  |
                                                </span>
                                              )}
                                            </React.Fragment>
                                          ))}
                                      </div>
                                      <span
                                        className="text-muted"
                                        style={{
                                          fontSize: "1rem",
                                          marginTop: "0",
                                        }}
                                      >
                                        {option.restaurant}
                                      </span>
                                    </div>
                                  </Box>
                                )}
                              />
                            );
                          }
                        })()}
                      </div>
                      <button
                        className="btn modalAddButton"
                        onClick={() => {
                          handleOpen();
                        }}
                      >
                        +Add Employee
                      </button>
                    </div>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>Logo</Typography>
                  </Grid>
                  <Grid xs={9}>
                    <Button
                      variant="contained"
                      component="label"
                      //   color="primary"
                      className="uploadButton"
                      // style={{ backgroundColor: 'white', color: 'gray' }}
                    >
                      <img
                        src={galleryIcon}
                        alt="photo"
                        // style={{ width: '2rem' }}
                      />
                      Upload
                      <input
                        hidden
                        accept="image/*"
                        // multiple
                        type="file"
                        onChange={handleImageUpload}
                        disabled={state.selectedImages.length >= 1}
                      />
                    </Button>
                  </Grid>

                  {/* image show start */}
                  <Grid container sx={{ padding: "0.5rem" }}>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={9}>
                      <Grid container spacing={2}>
                        {state.selectedImages.map((image, index) => (
                          <Grid item xs={2} sm={2} md={2} key={index}>
                            {/* <Paper> */}
                            <div
                              style={{
                                position: "relative",
                                paddingTop: "20px",
                              }}
                            >
                              <img
                                src={image}
                                alt={`Preview ${index + 1}`}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <IconButton
                                style={{
                                  position: "absolute",
                                  top: "-6px",
                                  right: "-23px",
                                  color: "gray",
                                }}
                                onClick={() => handleDeleteImage(index)}
                              >
                                <CancelIcon />
                              </IconButton>
                            </div>
                            {/* </Paper> */}
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* image show end */}
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Cover photo
                    </Typography>
                  </Grid>
                  <Grid xs={9}>
                    <Button
                      variant="contained"
                      component="label"
                      //   color="primary"
                      className="uploadButton"
                      // style={{ backgroundColor: 'white', color: 'gray' }}
                    >
                      <img
                        src={galleryIcon}
                        alt="photo"
                        // style={{ width: '2rem' }}
                      />
                      Upload
                      <input
                        hidden
                        accept="image/*"
                        multiple={false}
                        type="file"
                        onChange={handleBackgroundImageUpload}
                        disabled={
                          BackgroundImagestate.selectedImages.length >= 1
                        }
                      />
                    </Button>
                  </Grid>

                  {/* image show start */}
                  <Grid container sx={{ padding: "0.5rem" }}>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={9}>
                      <Grid container spacing={2}>
                        {BackgroundImagestate.selectedImages.map(
                          (image, index) => (
                            <Grid item xs={2} sm={2} md={2} key={index}>
                              {/* <Paper> */}
                              <div
                                style={{
                                  position: "relative",
                                  paddingTop: "20px",
                                }}
                              >
                                <img
                                  src={image}
                                  alt={`Preview ${index + 1}`}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                                <IconButton
                                  style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-23px",
                                    color: "gray",
                                  }}
                                  onClick={() =>
                                    handleBackgroundDeleteImage(index)
                                  }
                                >
                                  <CancelIcon />
                                </IconButton>
                              </div>
                              {/* </Paper> */}
                            </Grid>
                          ),
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* image show end */}
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Premises Image
                    </Typography>
                  </Grid>
                  <Grid xs={9}>
                    <Button
                      variant="contained"
                      component="label"
                      //   color="primary"
                      className="uploadButton"
                      // style={{ backgroundColor: 'white', color: 'gray' }}
                    >
                      <img
                        src={galleryIcon}
                        alt="photo"
                        // style={{ width: '2rem' }}
                      />
                      Upload
                      <input
                        hidden
                        accept="image/*"
                        multiple
                        type="file"
                        onChange={handlePremisesImageUpload}
                        disabled={PremisesImagestate.selectedImages.length >= 5}
                      />
                    </Button>
                  </Grid>

                  {/* image show start */}
                  <Grid container sx={{ padding: "0.5rem" }}>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={9}>
                      <Grid container spacing={2}>
                        {PremisesImagestate.selectedImages.map(
                          (image, index) => (
                            <Grid item xs={2} sm={2} md={2} key={index}>
                              {/* <Paper> */}
                              <div
                                style={{
                                  position: "relative",
                                  paddingTop: "20px",
                                }}
                              >
                                <img
                                  src={image}
                                  alt={`Preview ${index + 1}`}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                                <IconButton
                                  style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-23px",
                                    color: "gray",
                                  }}
                                  onClick={() =>
                                    handlePremisesDeleteImage(index)
                                  }
                                >
                                  <CancelIcon />
                                </IconButton>
                              </div>
                              {/* </Paper> */}
                            </Grid>
                          ),
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* image show end */}
                </Grid>
                {/* <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        City Name
                                    </Typography>
                                </Grid>
                                <Grid item xs={10}>
                                    <AutoCompleteMultiSelect
                                        label={''}
                                        placeholder={'City Name'}
                                        value={addValue}
                                        datas={CityDatas}
                                        id={1}
                                    />
                                </Grid>

                            </Grid> */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Service Charge % (Optional)
                    </Typography>
                  </Grid>
                  <Grid item xs={9.5}>
                    <TextAreaComponents
                      id={2}
                      label={"Service Charge (In Amount)"}
                      value={(props) => {
                        newRestaurant.ServiceCahrge = props;
                      }}
                    />
                  </Grid>
                  <Grid item xs={0.5} sx={{ padding: "0.5rem" }}>
                    <Checkbox
                      checked={serviceChargeCompulsoryCheck}
                      onChange={handleServiceChargeCompulsoryCheck}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Hygiene rating (Out of 10)
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      id={3}
                      label={"Hygiene rating (Out of 10)"}
                      value={(props) => {
                        newRestaurant.HygeneRating = props;
                      }}
                      min={1}
                      max={10}
                    />
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Preview
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Switch
                      checked={Preview}
                      onChange={handlePreviewSwitchChange}
                      inputProps={{ "aria-label": "controlled" }}
                      disabled={Preview}
                    />
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      HomeCook
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Switch
                      checked={HomeCook}
                      onChange={handleHomeCookSwitchChange}
                      inputProps={{ "aria-label": "controlled" }}
                      disabled={HomeCook}
                    />
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Is Pet Friendly
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Switch
                      checked={switchCheck}
                      onChange={handleSwitchChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Delivery
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Grid item xs={12}>
                      <Switch
                        checked={DeliveryswitchCheck}
                        onChange={handleDeliverySwitchChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                    {DeliveryswitchCheck && (
                      <Grid
                        container
                        spacing={2}
                        sx={{ padding: "0.5rem", alignItems: "center" }}
                      >
                        {/* Takeaway Restaurant Switch */}
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography
                            fontSize={14}
                            style={{ marginRight: "1rem" }}
                          >
                            TAKEAWAY RESTAURANT
                          </Typography>
                          <Switch
                            checked={DeliveryOnlyswitchCheck}
                            onChange={handleDeliveryOnlySwitchChange}
                            inputProps={{
                              "aria-label": "Takeaway Restaurant Switch",
                            }}
                            size="small"
                          />
                        </Grid>

                        {/* Collection Only Switch */}
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography
                            fontSize={14}
                            style={{ marginRight: "1rem" }}
                          >
                            COLLECTION ONLY
                          </Typography>
                          <Switch
                            checked={CollectionswitchCheck}
                            onChange={handleCollectionSwitchChange}
                            inputProps={{
                              "aria-label": "Collection Only Switch",
                            }}
                            size="small"
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Wifi Details
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Grid item xs={12}>
                      <Switch
                        checked={wifiCheck}
                        onClick={handleWifiCheck}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>

                    {wifiCheck && (
                      <Grid container sx={{ padding: "0.5rem" }}>
                        <Grid item xs={2}>
                          <Typography
                            fontSize={14}
                            style={{ paddingTop: "0.2rem" }}
                          >
                            Set Wifi As Public
                          </Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <Switch
                            checked={wifiPublicCheck}
                            onChange={handleWifiPublicCheck}
                            inputProps={{ "aria-label": "controlled" }}
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={9} style={{ paddingTop: "1rem" }}>
                          <TextField
                            fullWidth
                            id="outlined"
                            label="Network"
                            onChange={(e) => setwifiSSID(e.target.value)}
                            value={wifiSSID}
                            autoComplete="off"
                          />
                        </Grid>
                        {!wifiPublicCheck && (
                          <Grid item xs={9} style={{ paddingTop: "1rem" }}>
                            <FormControl
                              sx={{ width: "100%" }}
                              variant="outlined"
                            >
                              <InputLabel htmlFor="outlined-adornment-password">
                                Password
                              </InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-password"
                                value={wifiPassWord}
                                onChange={(e) =>
                                  setwifiPassWord(e.target.value)
                                }
                                type={showPassword ? "text" : "password"}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label={
                                        showPassword
                                          ? "hide the password"
                                          : "display the password"
                                      }
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                      onMouseUp={handleMouseUpPassword}
                                      edge="end"
                                    >
                                      {showPassword ? (
                                        <VisibilityOff />
                                      ) : (
                                        <Visibility />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                }
                                label="Password"
                                autoComplete="new-password"
                              />
                            </FormControl>
                          </Grid>
                        )}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                {/* Web Link Field */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Web Link
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <Grid container sx={{}}>
                      <Grid item xs={10}>
                        <TextAreaComponents
                          label={"example: 'zyz.com' || 'abc.org'"}
                          value={(props) => {
                            SetWebLink(props);
                          }}
                          val={webLink}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <div className="d-flex h-100 ms-2">
                          <Button
                            className="AddItemButtons"
                            onClick={() => {
                              addWebLink();
                            }}
                          >
                            Add
                          </Button>
                        </div>
                      </Grid>

                      <Grid item xs={12} className="mt-3">
                        {webLinkList.length > 0 ? (
                          <RestaurantTable
                            lists={webLinkList}
                            getTypeWriterData={getWebLinkData}
                          />
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Spotify playlist */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Spotify Playlist Link
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <Grid container sx={{}}>
                      <Grid item xs={10}>
                        <TextAreaComponents
                          label={"Spotify Playlist Link"}
                          value={(props) => {
                            SetspotifyLink(props);
                          }}
                          val={spotifyLink}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <div className="d-flex h-100 ms-2">
                          <Button
                            className="AddItemButtons"
                            onClick={() => {
                              addtoSpotifyLinksList();
                            }}
                          >
                            Add
                          </Button>
                        </div>
                      </Grid>

                      <Grid item xs={12} className="mt-3">
                        {spotifyLinkList.length > 0 ? (
                          <RestaurantTable
                            lists={spotifyLinkList}
                            getTypeWriterData={getSpotifyData}
                          />
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid
                    item
                    xs={2}
                    className="d-flex gap-2"
                    sx={{ paddingTop: "1rem" }}
                  >
                    <Typography style={{}}>
                      Animated Cover photo text:
                    </Typography>
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            Write a short blurb about your motto, tagline,
                            passions, etc. You can add more than one animated
                            text for your cover photo.
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "#371B17" }} />
                    </HtmlTooltip>
                  </Grid>
                  <Grid item xs={10}>
                    <Grid container sx={{}}>
                      <Grid item xs={10}>
                        <TextAreaComponents
                          label={"Text"}
                          value={(props) => {
                            SettypewriterText(props);
                          }}
                          val={typewriterText}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <div className="d-flex h-100 ms-2">
                          <Button
                            className="AddItemButtons"
                            onClick={() => {
                              addtoTypewriterList();
                            }}
                          >
                            Add
                          </Button>
                        </div>
                      </Grid>

                      <Grid item xs={12} className="mt-3">
                        {typewriterTextList.length > 0 ? (
                          <RestaurantTable
                            lists={typewriterTextList}
                            getTypeWriterData={getTypeWriterData}
                          />
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={10}></Grid>
                  <Grid item xs={2}>
                    <Button
                      className="AddItemButtons"
                      onClick={() => {
                        submit();
                      }}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </DialogContent>

            {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
          </Dialog>
        </React.Fragment>
        <AddEmpDialog
          open={open}
          onHandleAddItem={handleAddItem}
          title={props.title}
        ></AddEmpDialog>

        {/* <Schedulepreviwdialog

        onHandleAddItem={handleConfirmLastOrderTimes}
        >

        </Schedulepreviwdialog> */}
        <AddressAddModal
          showModal={showAddressModal}
          handleClose={handleCloseAddressModal}
          changeAddress={handleAddressSelect}
        />
      </div>
    </>
  );
}

export default AddRestaurantDialog;
